export const GET_POOL_REQUEST_INBOX_FAILURE = 'GET_POOL_REQUEST_INBOX_ERROR';

export const getPoolRequestInboxFailure = ({ error, request }) => ({
    type: GET_POOL_REQUEST_INBOX_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});